import { useMediaQuery } from 'react-responsive';

type Props = 'sm' | 'mobile' | 'tablet' | 'desktop';
export default function useResponsive(type: Props) {
  const tablet = useMediaQuery({ query: '(max-width: 1169px)' });

  const mobile = useMediaQuery({ query: '(max-width: 768px)' });

  const sm = useMediaQuery({ query: '(max-width: 500px)' });

  const desktop = useMediaQuery({ query: '(min-width: 1170px)' });

  switch (type) {
    case 'sm':
      return sm;
    case 'mobile':
      return mobile;
    case 'tablet':
      return tablet;
    case 'desktop':
      return desktop;
    default:
      return false;
  }
}
